import { AxiosInstance, AxiosResponse } from 'axios'

export interface ApiKey {
  id: string
  keyName: string
  apiKeyPrefix: string
  createdDate: string
  /** Granted scopes, exactly as chosen: a `<group>:all` is stored rather than expanded. */
  scopes: string[]
  /** A fine-grained key reaches only the Teammates and Teams below, and cannot create anything. */
  isFineGrained: boolean
  teammateIds: string[]
  teamIds: string[]
}

export interface ApiKeyCreatePayload {
  keyName: string
  scopes?: string[]
  isFineGrained?: boolean
  teammateIds?: string[]
  teamIds?: string[]
}

export type ApiKeyUpdatePayload = Partial<ApiKeyCreatePayload>

export interface ApiKeyCreateResponse extends ApiKey {
  apiKey: string
}

export default class ApiKeyApi {
  constructor(private client: AxiosInstance) {}

  getAllAPIKeys = (): Promise<AxiosResponse<ApiKey[]>> => this.client.get('/apiKeys')

  createNewAPI = (body: ApiKeyCreatePayload): Promise<AxiosResponse<ApiKeyCreateResponse>> => this.client.post(`/apiKeys`, body)

  updateAPI = (id: string, body: ApiKeyUpdatePayload): Promise<AxiosResponse<ApiKey>> => this.client.put(`/apiKeys/${id}`, body)

  deleteAPI = (id: string): Promise<AxiosResponse<any>> => this.client.delete(`/apiKeys/${id}`)
}
